const SingleProjectView = Barba.BaseView.extend({
    namespace: 'single-project',
    pannellumView: null,
    panoWrapper: null,

    onEnter() {
        new MainMenu(this.container);
        new InViewAnimation();
        new ReadMoreTrigger(this.container);
        new SearchModal(this.container);

        initSlideshows(this.container);
        setIframeAspectRatios(this.container);

        this.initArModal();
        this.init360Pano();
        this.initNewsGridSliders();

        const prevState = Barba.HistoryManager.prevStatus();
        if (prevState && typeof prevState.namespace !== 'undefined' && prevState.namespace === 'archive') {
            const backLink = this.container.querySelector('.jsProjectBackLink');
            backLink.addEventListener('click', e => {
                e.preventDefault();
                window.history.back();
            });
        }
    },

    initNewsGridSliders() {
        this.container.querySelectorAll('.jsNewsGridSlider').forEach(el => new NewsGridSlider(el));
    },

    initArModal() {
        const arModalTrigger = this.container.querySelector('.jsProjectArBtn');

        if (arModalTrigger !== null) {
            const arWrapper = arModalTrigger.parentElement.querySelector('.jsProjectArWrapper');

            if (arWrapper) {
                document.addEventListener('keyup', e => {
                    if (e.key.toLowerCase() === 'escape') {
                        arWrapper.classList.remove('visible');
                    }
                });

                arWrapper.addEventListener('click', e => {
                    if (e.target.classList.contains('jsClose')) {
                        e.preventDefault();
                        arWrapper.classList.remove('visible');
                    }
                });

                arModalTrigger.addEventListener('click', e => {
                    if (window.innerWidth >= 550) {
                        e.preventDefault();
                        arWrapper.classList.add('visible');
                    }
                });
            }
        }
    },

    init360Pano() {
        const panoTrigger = this.container.querySelector('.jsProject360Btn');

        if (panoTrigger !== null) {
            panoTrigger.addEventListener('click', _ => {
                // Create a panorama wrapper
                const uniqid = Math.random() * 16;
                this.panoWrapper = document.createElement('div');
    
                this.panoWrapper.classList.add('pano-wrapper');
                this.panoWrapper.id = 'pano-wrapper-' + uniqid;

                const closeBtn = document.createElement('button');
                closeBtn.type = 'button';
                closeBtn.classList.add('pano-wrapper__close-btn');
                this.panoWrapper.appendChild(closeBtn);

                // Add a close event listener
                closeBtn.addEventListener('click', _ => this.closePano());

                // Add to the body
                this.panoWrapper.style.opacity = 0;
                document.body.appendChild(this.panoWrapper);

                // Init the viewer
                this.pannellumView = pannellum.viewer('pano-wrapper-' + uniqid, {
                    'type': 'equirectangular',
                    'panorama': panoTrigger.dataset.panoUrl,
                    'autoLoad': true
                });

                // Show the panorama
                TweenLite.to(this.panoWrapper, 0.5, { opacity: 1, ease: Power2.easeInOut });
            });
        }
    },

    closePano() {
        TweenLite.to(this.panoWrapper, 0.5, { opacity: 0, ease: Power2.easeInOut, onComplete: _ => {
            this.pannellumView.destroy();
            this.panoWrapper.parentElement.removeChild(this.panoWrapper);
        } });
    }
});

SingleProjectView.init();
